'use client';

import { useTranslations } from 'next-intl';
import { MyEquipmentLoader } from '../my-equipment/my-equipment-loader';
import { ProductCardGridLoader } from '../../product-card/product-card-loader';
import { ServiceInsightSkeletonLoader } from '../service-Insight/service-insight-card/service-insight-loader';
import sidePanelList from '../side-panel-list';

export const CustomerAccountLoading = ({ menu }) => {
  const sideMenuList = sidePanelList();
  const t = useTranslations();
  switch (menu) {
    case sideMenuList.myEquipment.name:
      return <MyEquipmentLoader />;
    case sideMenuList.recentlyViewed.name:
      return <ProductCardGridLoader title={t('RECENTLY_VIEWED')} />;
    case sideMenuList.serviceRecommendation.name:
      return <ServiceInsightSkeletonLoader />;
    case sideMenuList.buyAgain.name:
      return <>{/* in future Loader component can be added here */}</>;
    default:
      return (
        <>
          <MyEquipmentLoader />
          <ProductCardGridLoader title={t('RECENTLY_VIEWED')} />
          <ServiceInsightSkeletonLoader />
        </>
      );
  }
};
